import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import NewsletterSubscriber from './newsletter_subscriber';
import NewsletterSignupForm from './newsletters_form';

class NewslettersPageForm extends NewsletterSubscriber {
  render() {
    const formParams = {
      handleEmailUpdate: this.handleEmailUpdate,
      emailValue: this.state.email,
      handleSignupSubmit: this.handleSubmit,
      disabled: this.state.disabled,
      placeholder:
        get(this.statusMessages, [this.state.status]) || 'YOUR EMAIL ADDRESS',
      listsDictionary: this.props.listsDictionary,
      sections: this.props.sections,
      state: this.state.newsletters,
      filter: false,
      transition: false,
      handleNewslettersUpdate: this.handleUpdate,
      hed: this.props.hed,
      dek: this.props.dek,
      handleVerify: this.handleVerify,
      reCaptchaPublic: this.props.config.reCaptcha
    };
    return <NewsletterSignupForm {...formParams} />;
  }
}

NewslettersPageForm.propTypes = {
  listsDictionary: PropTypes.shape({}).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default NewslettersPageForm;



// WEBPACK FOOTER //
// ./src/views/components/newsletters/newsletters_page_form_with_state.js